<p-dialog 
    [header]="(isEditMode ? 'rooms_edit_title' : 'rooms_new_title') | translate" 
    [visible]="true" 
    (visibleChange)="onClose()"
    [modal]="true" 
    [draggable]="false" 
    [resizable]="false"
    [style]="{ width: '450px' }"
    styleClass="premium-dialog"
    appendTo="body">
    
    <div class="pt-4">
        <form [formGroup]="roomForm" class="flex flex-col gap-5">
            <!-- Name Field -->
            <div class="flex flex-col gap-1.5">
                <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                    {{ 'rooms_field_name' | translate }}<span class="text-red-500">*</span>
                </label>
                <input 
                    type="text" 
                    pInputText 
                    formControlName="name" 
                    [placeholder]="'rooms_placeholder_name' | translate"
                    class="w-full !rounded-xl !py-3 bg-slate-50 border-slate-100 focus:border-primary transition-all shadow-sm">
                <small *ngIf="roomForm.get('name')?.touched && roomForm.get('name')?.invalid" class="text-red-500 text-[10px] font-bold ml-1 uppercase">
                    {{ 'common_field_required' | translate }}
                </small>
            </div>

            <!-- Location Field -->
            <div class="flex flex-col gap-1.5">
                <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                    {{ 'rooms_field_location' | translate }}<span class="text-red-500">*</span>
                </label>
                <input 
                    type="text" 
                    pInputText 
                    formControlName="location" 
                    [placeholder]="'rooms_placeholder_location' | translate"
                    class="w-full !rounded-xl !py-3 bg-slate-50 border-slate-100 focus:border-primary transition-all shadow-sm">
                <small *ngIf="roomForm.get('location')?.touched && roomForm.get('location')?.invalid" class="text-red-500 text-[10px] font-bold ml-1 uppercase">
                    {{ 'common_field_required' | translate }}
                </small>
            </div>

            <!-- Capacity Field -->
            <div class="flex flex-col gap-1.5">
                <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
                    {{ 'rooms_field_capacity' | translate }}<span class="text-red-500">*</span>
                </label>
                <p-inputNumber 
                    formControlName="capacity" 
                    [placeholder]="'rooms_placeholder_capacity' | translate"
                    [min]="1" [showButtons]="true"
                    buttonLayout="horizontal"
                    decrementButtonClass="p-button-secondary !rounded-l-xl"
                    incrementButtonClass="p-button-secondary !rounded-r-xl"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                    inputStyleClass="w-full !text-center !py-3 bg-slate-50 border-slate-100"
                    styleClass="w-full !rounded-xl overflow-hidden shadow-sm">
                </p-inputNumber>
                <small *ngIf="roomForm.get('capacity')?.touched && roomForm.get('capacity')?.invalid" class="text-red-500 text-[10px] font-bold ml-1 uppercase">
                    {{ 'common_field_required' | translate }}
                </small>
            </div>

        </form>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-end items-center gap-3 pt-4 border-t border-slate-50">
            <button 
                (click)="onClose()" 
                class="px-6 py-2.5 text-[10px] font-black text-slate-400 uppercase tracking-widest hover:text-slate-600 transition-colors">
                {{ 'CANCEL' | translate }}
            </button>
            <app-button 
                [label]="(isEditMode ? 'common_update' : 'common_save') | translate" 
                [loading]="loading" 
                (onClick)="onSave()" 
                [disabled]="roomForm.invalid || loading"
                styleClass="!rounded-full !py-2.5 !px-10 !bg-primary !text-[11px] shadow-lg shadow-primary/20">
            </app-button>
        </div>
    </ng-template>
</p-dialog>
